import React, { PureComponent, memo } from 'react';
import { withRouter } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap'
import { connect } from 'react-redux';
import { Nav, Navbar, NavDropdown } from 'react-bootstrap';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
library.add(fas);

import { Notificacion } from '../../Util/Notificacion/Notificacion';
import { Obtener_Menu_Request } from '../../../request/MenuRequest';
import { SiteRutas } from '../../../request/RutasConfig';

class Menu extends PureComponent {
    state = {
        lstMenu: []
    }

    componentDidMount() {
        this.cargarMenu();
    }

    cargarMenu = async () => {
        if (this.props.token) {
            const response = await Obtener_Menu_Request(this.props.token);
            if (response.Exitoso) {
                const lstMenu = response.Datos;
                this.setState({ lstMenu });

                const extraPage = [SiteRutas.Base, SiteRutas.CambiarContrasena, SiteRutas.Home, SiteRutas.Parametros, SiteRutas.MonitorCallCenterDetalle];
                const pathname = this.props.location.pathname;
                if (!extraPage.includes(pathname) && lstMenu && lstMenu.length > 0) {

                    const indexMenu = lstMenu.findIndex(menu => menu.Menu_Url === pathname);
                    if (indexMenu < 0) {
                        this.props.history.replace({ pathname: SiteRutas.Home });
                    }
                }
            }
            else {
                Notificacion.error(response.Mensaje);
            }
        }
    }

    render() {
        const { lstMenu } = this.state;

        let htmlMenu = null;
        if (lstMenu && lstMenu.length > 0) {
            const lstMenusPadres = lstMenu.filter(option => { return option.Menu_Padre === 0; });
            if (lstMenusPadres && lstMenusPadres.length > 0) {

                htmlMenu = lstMenusPadres.map(opcionPadre => {

                    const opcionesMenu = lstMenu.filter(option => { return option.Menu_Padre === opcionPadre.Menu_Id; });

                    return <NavDropdown key={opcionPadre.Menu_Id} title={opcionPadre.Menu_Nombre} id={`menu${opcionPadre.Menu_Id}`}>

                        {
                            opcionesMenu && opcionesMenu.length > 0 ?
                                opcionesMenu.map(opcionMenu => {
                                    return <LinkContainer key={opcionMenu.Menu_Id} to={{
                                        pathname: opcionMenu.Menu_Url,
                                        state: { menuId: opcionMenu.Menu_Id }
                                    }}>
                                        <NavDropdown.Item><FontAwesomeIcon icon={opcionMenu.Menu_Imagen} /> {opcionMenu.Menu_Nombre}</NavDropdown.Item>
                                    </LinkContainer>;
                                })
                                : null
                        }
                    </NavDropdown>;
                });
            }
        }

        return (
            <div className="content menu2">
                <Navbar collapseOnSelect={true} expand="lg">
                    <LinkContainer to={SiteRutas.Home}><Navbar.Brand >LDCOM EXPRESS</Navbar.Brand></LinkContainer>
                    <Navbar.Toggle aria-controls="menuExpress" />
                    <Navbar.Collapse id="menuExpress">
                        <Nav className="mr-auto">
                            {
                                htmlMenu
                            }
                        </Nav>
                        {this.props.children}
                    </Navbar.Collapse>
                </Navbar>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        token: state.usuario.token
    };
};

export default connect(mapStateToProps)(withRouter(memo(Menu)));